import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./modules/dashboard/dashboard.component').then((m) => m.DashboardComponent),
  },
  {
    path: 'bank/:pubkey',
    loadComponent: () =>
      import('./modules/bank-details/bank-details.component').then((m) => m.BankDetailsComponent),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
